import React from 'react' 

const HelpForm = (props: any) : JSX.Element => {
  return (
    <div>HelpForm</div>
  )
} 

export default HelpForm